import { render, staticRenderFns } from "./WhatsAppFloater.vue?vue&type=template&id=676daf71"
import script from "./WhatsAppFloater.vue?vue&type=script&lang=js"
export * from "./WhatsAppFloater.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppFloater.vue?vue&type=style&index=0&id=676daf71&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports